import {
  getContent,
  mergeContent,
  newModal,
  mergeModalState,
  closeModal,
} from "@js/helpers/state.js";

import {
  CE_MODAL_CHANGE_HTML_EDITOR_OPEN,
  CE_MODAL_CHANGE_HTML_EDITOR_SAVE,
  CE_MODAL_CHANGE_HTML_EDITOR_CONFIRM,
  CE_MODAL_CHANGE_HTML_EDITOR_CANCEL,
} from "@js/actions/studio/campaign_content_section/modal_change_html_editor.js";

const doSwitchEditor = (state, isConfirmed) => {
  let { client_content_id, active_html_editor: editor } = state.modal.state;
  let content = getContent(state, client_content_id);

  if (content.active_html_editor === editor) {
    return closeModal(state);
  }

  if (!isConfirmed) {
    let getWarning = (prev, next) => {
      const warningKey = `${prev}_to_${next}`;

      const warnings = [
        "bee_to_textarea",
        "bee_to_wysiwyg",
        "wysiwyg_to_bee",
        "textarea_to_bee",
        "textarea_to_wysiwyg",
      ];

      // Don't need to warn if no content has been saved.
      if (content.html === "") {
        return null;
      }

      if (warnings.includes(warningKey)) {
        return t(`phrases.react_content.change_editor_warning.${warningKey}`);
      } else {
        return null;
      }
    };

    let warning = getWarning(content.active_html_editor, editor);

    if (warning) {
      // We have a warning to issue the user.
      return mergeModalState(state, {
        step: "confirm",
        warning: warning,
      });
    }
  }

  if (editor === "bee") {
    // We're converting to BEE. We have to blank out the content.
    return mergeContent(closeModal(state), client_content_id, {
      active_html_editor: editor,
      html: "",
      bee_json: null,
    });
  } else {
    // Otherwise we leave the current HTML in place, but ensure we don't have a bee_json.
    return mergeContent(closeModal(state), client_content_id, {
      active_html_editor: editor,
      bee_json: null,
    });
  }
};

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_CHANGE_HTML_EDITOR_OPEN: {
      let { client_content_id } = action;
      let content = getContent(state, client_content_id);

      return newModal(state, "change_html_editor", {
        step: "select",
        client_content_id: client_content_id,
        active_html_editor: content.active_html_editor,
      });
    }

    case CE_MODAL_CHANGE_HTML_EDITOR_SAVE: {
      return doSwitchEditor(state, false);
    }

    case CE_MODAL_CHANGE_HTML_EDITOR_CONFIRM: {
      return doSwitchEditor(state, true);
    }

    case CE_MODAL_CHANGE_HTML_EDITOR_CANCEL: {
      return closeModal(state);
    }

    default:
      return state;
  }
};
